import http from 'hub-http/clients/noAuthApiClient';
const API_BASE = '/login-api/v1';
export default class LoginAPI {
  static redirectToUrl(loginRedirectUrl) {
    return http.get(`${API_BASE}/redirect}`, {
      query: {
        loginRedirectUrl
      }
    });
  }
  static validateRedirectUrl(loginRedirectUrl) {
    return http.get(`${API_BASE}/redirect/validate`, {
      query: {
        loginRedirectUrl
      }
    });
  }
}